import { LEGAL_CONSENT_VERSION } from "../../../shared/legalConsent";

/**
 * Lokale Spiegelung der akzeptierten Consent-Version (localStorage). Dient als
 * Fallback/Sofort-Entscheidung im Consent-Gate; maßgeblich für eingeloggte
 * Nutzer bleibt die serverseitig gespeicherte Version.
 */
const LOCAL_CONSENT_KEY = "preflight.legal_consent_version";

export function getLocalConsentVersion(): string | null {
  try {
    return localStorage.getItem(LOCAL_CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setLocalConsentVersion(
  version: string = LEGAL_CONSENT_VERSION,
): void {
  try {
    localStorage.setItem(LOCAL_CONSENT_KEY, version);
  } catch {
    // localStorage kann blockiert sein — Server bleibt die maßgebliche Quelle.
  }
}
